import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

/**
 * EmptyState - حالة المحادثة الفارغة
 * @param {Function} t - دالة الترجمة
 */
export function EmptyState({ t }) {
  const greetings = t("greetings");
  
  return (
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="flex flex-col items-center justify-center h-full text-center pt-20 md:pt-16 pb-16 px-4"
    >
      <motion.div 
        className="w-16 h-16 rounded-2xl bg-secondary flex items-center justify-center mb-5"
        animate={{ y: [0, -6, 0] }}
        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
      >
        <Sparkles className="w-8 h-8 text-muted-foreground" />
      </motion.div>
      
      <h2 className="text-xl font-bold text-foreground mb-2">{t("startNewChat")}</h2>
      <p className="text-muted-foreground text-sm mb-6">{t("aiWillRespond")}</p>
      
      <div className="flex items-center gap-2 flex-wrap justify-center">
        {(Array.isArray(greetings) ? greetings : ["Hello", "Hi", "Hey"]).map((text, i) => (
          <motion.span
            key={text}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3 + i * 0.1 }}
            className="px-3 py-1.5 rounded-full bg-secondary text-xs text-muted-foreground"
          >
            {text}
          </motion.span>
        ))}
      </div>
    </motion.div>
  );
}

export default EmptyState;
